import GSAP from 'gsap'

export default class PageTransition {
	constructor(el) {
		this.element 			= el
		this.init 				= this.init.bind(this)
		this.pageIn 			= this.pageIn.bind(this)
		this.introAnimation 	= GSAP.timeline({
			paused: true,
			duration: '0.3'
		})
		this.leaveAnimation 	= GSAP.timeline({
			paused: true,
			duration: '0.3'
		})

		this.introAnimation.fromTo(this.element, {
			clipPath: 'inset(0 0 0 0)',
		},{
			clipPath: 'inset(0% 0% 100% 0%)',
			onComplete: () => {
				window.emitter.emit('pageReady'),
				window.document.body.classList.add('loaded')
			}
		})

	}

	init() {

		this.pageIn()

		// Listen for page leave
		window.addEventListener('popstate', () => {
			const linkType = document.activeElement.protocol
		
			if(linkType === 'http:' || linkType === 'https:') {
				this.pageLeave()
			}
		})


	}

	pageLeave() {

		this.leaveAnimation.fromTo(this.element, {
			clipPath: 'inset(100% 0 0 0)',
		},{
			clipPath: 'inset(0% 0% 0 0%)',
		})

		this.leaveAnimation.play()

	}

	pageIn() {

		this.introAnimation.play()

	}

}